<template>
  <div class="alert alert-warning text-start text-dark">
    <span class="badge bg-warning me-2">Debug</span
    ><span class="fw-bold">Correct:</span> {{ correct }}
  </div>
  <div class="alert alert-warning text-start text-dark">
    <span class="badge bg-warning me-2">Debug</span
    ><span class="fw-bold">Clicked:</span> {{ lastClicked }}
  </div>
  <div class="alert alert-warning text-start text-dark">
    <span class="badge bg-warning me-2">Debug</span
    ><span class="fw-bold">Was clicked correct:</span> {{ clickedCorrect }}
  </div>
  <div class="alert alert-warning text-start text-dark">
    <div class="fw-bold mb-3">
      <span class="badge bg-warning me-2">Debug</span> Distractors
    </div>

    <pre class="bg-light border p-3">{{ distractors }}</pre>
  </div>
  <div class="alert alert-warning text-start text-dark">
    <div class="fw-bold mb-3">
      <span class="badge bg-warning me-2">Debug</span> Prompts (Shuffled)
    </div>

    <pre class="bg-light border p-3">{{ shuffledNames }}</pre>
  </div>
</template>

<script>
export default {
  name: "DebugPanel",
  props: {
    correct: String,
    clickedCorrect: Boolean,
    lastClicked: String,
    distractors: Array,
    shuffledNames: Array
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress {
  height: 5px;
}
</style>
